<template>
	<div>
		<el-dialog title="修改邮箱" :visible.sync="changedialog" width="600px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :headtitle="changetitle" :isdiag="true"></minhead> -->
			<div class="horizontally">
				<div style="margin-right: 100px;margin-top: 30px;">
					<el-form :model="editEmailForm" label-width="100px" class="demo-ruleForm">
						<el-form-item label="邮箱地址"><el-input v-model="editEmailForm.emailAddress" style="width: 215px;"></el-input></el-form-item>
					</el-form>
				</div>
			</div>
			<div style="justify-content: right; display: flex;">
				<div class="addstyle" style="width:60px;margin-right: 20px;" @click="saveEmailChange">保存</div>
				<!-- <el-button type="primary" @click="saveEmailChange">保存</el-button> -->
				<!-- <el-button @click="changedialog = false">关闭</el-button> -->
				<div class="backstyle" style="width:60px" @click="changedialog = false">关闭</div>
			</div>
		</el-dialog>
		<el-dialog title="发票预览" :visible.sync="docPreviewDialog" style="padding-left: 5%;padding-right: 5%" width="900px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :noheadtou="true" :headtitle="docPreview" :isdiag="true"></minhead> -->
			<iframe :src="ifsrc" :type="pdftype" style="width:98%;margin-left:1%;margin-right: 1%; height: 65vh;overflow: scroll" />
			<div style="justify-content: right; display: flex;margin-top: 10px">
				<!-- <el-button @click="docPreviewDialog = false">关闭</el-button> -->
				<div class="backstyle" style="width:60px" @click="docPreviewDialog = false">关闭</div>
			</div>
		</el-dialog>
		<!-- 高级查询 -->
		<el-dialog title="高级查询" :visible.sync="cxdialog" width="900px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :headtitle="cxtitle" :isdiag="true"></minhead> -->
			<div style="width: 100%;" class="horizontally">
				<el-form label-width="100px" class="demo-ruleForm" :model="advancedQueryForm">
					<div class="Centerupdown">
						<el-form-item label="邮件发送状态:">
							<el-select v-model="advancedQueryForm.emailSendState" style="width: 215px;">
								<el-option label="全部" value=""></el-option>
								<el-option label="未发送" value="00"></el-option>
								<el-option label="已发送" value="1"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="OFD生成状态:" :label-width="formLabelWidth">
							<el-select v-model="advancedQueryForm.ofdGenerationState" style="width: 215px;">
								<el-option label="全部" value=""></el-option>
								<el-option label="未生成" value="00"></el-option>
								<el-option label="已生成" value="1"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div class="Centerupdown">
						<el-form-item label="邮箱地址:"><el-input v-model="advancedQueryForm.emailAddress" style="width:215px"></el-input></el-form-item>
						<el-form-item label="票必达推送状态:" :label-width="formLabelWidth">
							<el-select v-model="advancedQueryForm.invoiceSendState" style="width: 215px;">
								<el-option label="全部" value=""></el-option>
								<el-option label="未推送" value="00"></el-option>
								<el-option label="已推送" value="1"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div class="Centerupdown">
						<el-form-item label="发票代码:"><el-input v-model="advancedQueryForm.invoiceCode" style="width:215px"></el-input></el-form-item>

						<el-form-item label="发票号码:" :label-width="formLabelWidth">
							<el-input v-model="advancedQueryForm.invoiceNumber" style="width:215px"></el-input>
						</el-form-item>
					</div>
					<div class="Centerupdown">
						<el-form-item label="购方名称:"><el-input v-model="advancedQueryForm.buyerName" style="width:215px"></el-input></el-form-item>

						<el-form-item label="购方税号:" :label-width="formLabelWidth">
							<el-input v-model="advancedQueryForm.buyerNumber" style="width:215px"></el-input>
						</el-form-item>
					</div>
					<div class="Centerupdown">
						<el-form-item label="销方名称:"><el-input v-model="advancedQueryForm.sellerName" style="width:215px"></el-input></el-form-item>

						<el-form-item label="销方税号:" :label-width="formLabelWidth">
							<el-input v-model="advancedQueryForm.sellerNumber" style="width:215px"></el-input>
						</el-form-item>
					</div>
					<div class="Centerupdown">
						<el-form-item label="开票日期:">
							<el-date-picker
								v-model="advancedQueryForm.invoiceDate"
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								value-format="yyyyMMddHHmmss"
								end-placeholder="结束日期"
							></el-date-picker>
						</el-form-item>
					</div>
					<div class="Centerupdown">
						<el-form-item label="金     额:"><el-input v-model="advancedQueryForm.amount" style="width:215px"></el-input></el-form-item>

						<el-form-item label="税      额:" :label-width="formLabelWidth">
							<el-input v-model="advancedQueryForm.taxAmount" style="width:215px"></el-input>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" plain @click="advancedQuery" style="width: 100px;">筛选</el-button>
				<el-button type="primary" plain @click="reset" style="width: 100px;">重置</el-button>
				<el-button type="primary" plain @click="close" style="width: 100px;">关闭</el-button>
			</div>
		</el-dialog>

		<taxSearch :searchdata="searchalllist" :searchlist="searchlist" labelwidth="150px" labelPosition="left" @submitSearch="forshuai"></taxSearch>
		<el-dialog :visible.sync="showDocPushHistory" width="800px" :close-on-click-modal="false" v-dialogDrag title="推送记录">
			<minhead :headtitle="detailTitle" :isdiag="true"></minhead>
			<div class="detail-dialog">
				<div style="padding-top: 10px;">
					<el-table :data="detailTableData" border stripe height="300px" class="table" ref="companyTable">
						<el-table-column prop="pushType" label="推送类型" align="center">
							<template slot-scope="scope">
								<p v-if="scope.row.pushType == '1'">邮件</p>
								<p v-if="scope.row.pushType == '2'">微信卡包</p>
								<p v-if="scope.row.pushType == '3'">支付宝卡包</p>
							</template>
						</el-table-column>
						<el-table-column prop="pushStatus" label="推送状态" align="center">
							<template slot-scope="scope">
								<img src="../../../assets/img/stcg.png" width="31px" height="32px" v-if="scope.row.pushStatus === '1'" />
								<img src="../../../assets/img/tssb.png" width="31px" height="32px" v-else />
							</template>
						</el-table-column>
						<el-table-column prop="pushOperator" label="推送人" align="center"></el-table-column>
						<el-table-column prop="createTime" label="推送时间" align="center">
							<template slot-scope="scope">
								{{ formatDateTime(scope.row.createTime) }}
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div style="margin-top: 31px;padding-bottom: 21px;" class="between-line">
				<div></div>
				<!-- <div class="rightbuttom">
					<div @click="showDocPushHistory = false">关闭</div>
				</div> -->
				<div style="justify-content: right; display: flex;margin-top: 10px"><div class="backstyle" style="width:60px" @click="showDocPushHistory = false">关闭</div></div>
			</div>
		</el-dialog>
		<div class="headline"></div>
		<div class="areacontent">
			<div class="between-line">
				<div class="Centerupdown">
					<el-dropdown class="avatar-container" trigger="click" style="margin:0 10px" v-if="permissionButton('dpds_fpds','Telegraphicdelivery_FullyElectronic_invoice_delivery')">
						<!-- 	<div class="avatar-wrapper">
							<el-button type="primary" plain>
								发票递送
								<i class="el-icon-caret-bottom" />
							</el-button>
						</div> -->
						<div class="addstyle" style="width: 110px;">
							<samp>
								发票递送
								<i class="el-icon-caret-bottom" />
							</samp>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="sendEmailButton">邮件发送</el-dropdown-item>
							<el-dropdown-item @click.native="sendCarBatch">推送卡包</el-dropdown-item>
							<el-dropdown-item @click.native="sendInvoiceButton">{{ projectName == 'WGQ' ? '推送邮寄集成管理' : '推送票必达' }}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<el-dropdown class="avatar-container" trigger="click" style="margin:0 0px" v-if="permissionButton('dpds_scfpbs','Telegraphicdelivery_FullyElectronic_generate_invoice_layout')">
						<!-- <div class="avatar-wrapper">
							<el-button type="primary" plain>
								生成发票版式
								<i class="el-icon-caret-bottom" />
							</el-button>
						</div> -->
						<div class="addstyle" style="width: 120px;margin-right: 10px;	">
							<samp>
								生成发票版式
								<i class="el-icon-caret-bottom" />
							</samp>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="createOfd">OFD</el-dropdown-item>
							<el-dropdown-item @click.native="createPdf">PDF</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<div class="addstyle" @click="changeEmail" style="width: 120px;margin-right: 10px;" v-if="permissionButton('dpds_xgsjyx','Telegraphicdelivery_FullyElectronic_modify_recipient_email')">
						<samp>
							修改收件邮箱
							<i class="el-icon-edit  el-icon--right"></i>
						</samp>
					</div>

					<el-dropdown class="avatar-container" trigger="click" v-if="permissionButton('dpds_xzbswj','Telegraphicdelivery_FullyElectronic_download_layout_files')">
						<div class="addstyle" style="width: 120px;">
							<samp>
								下载版式文件
								<i class="el-icon-caret-bottom" />
							</samp>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="downloadDoc('3')">XML文件</el-dropdown-item>
							<el-dropdown-item @click.native="downloadDoc('2')">OFD文件</el-dropdown-item>
							<el-dropdown-item @click.native="downloadDoc('1')">PDF文件</el-dropdown-item>
							<el-dropdown-item @click.native="downloadDoc('0')">所有文件</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<!-- 	<el-button type="primary" plain @click="changeEmail" v-permission='dpds_xgsjyx'>
						修改收件邮箱
						<i class="el-icon-edit  el-icon--right"></i>
					</el-button> -->
				</div>
				<!--                <div class="Centerupdown">-->
				<!--                    <el-input-->
				<!--                            style="width: 300px;margin-left: 20px;margin-right: 16px;"-->
				<!--                            placeholder="发票代码、购方名称"-->
				<!--                            clearable-->
				<!--                            prefix-icon="el-icon-search"-->
				<!--                            v-model="likeQueryModel"-->
				<!--                            @input="forserchinput"-->
				<!--                    ></el-input>-->
				<!--                    <el-button class="moreserch" type="primary" plain @click="advancedQueryPopUp"-->
				<!--                               style="margin-right: 16px;">-->
				<!--                        高级查询-->
				<!--                        <i class="el-icon-search el-icon&#45;&#45;right"></i>-->
				<!--                    </el-button>-->
				<!--                </div>-->
			</div>
			<div class="areatable">
				<div class="tableh">
					<el-table
						:data="tableData"
						border
						style="width: 100%"
						height="calc(100vh - 330px )"
						ref="multipleTable"
						@selection-change="handleSelectionChange"
						@row-click="selectClick"
						@sort-change="tableSortChange"
					>
						<el-table-column type="selection" width="55" fixed="left"></el-table-column>
						<el-table-column prop="danjh" align="left" min-width="160px" show-overflow-tooltip label="单据号"></el-table-column>
						<el-table-column prop="fapzt" label="单据状态" min-width="100" align="center">
							<template slot-scope="scope">
								<!-- 发票状态 -1:草稿 0：入库保存；1：已审核；2：待开票；3：开票中；4：已开票；7：开票失败；8：暂不开票；9：已退票；34：无需开票 -->
								<p v-if="scope.row.fapzt == '-1'" style="color:#BEBEBE">草稿</p>
								<p v-if="scope.row.fapzt == '0'">待审核</p>
								<p v-if="scope.row.fapzt == '1'" style="color:#00DC16">已审核</p>
								<p v-if="scope.row.fapzt == '2'" style="color:#EE0101">待开票</p>
								<p v-if="scope.row.fapzt == '3'" style="color:#2F66FC">开票中</p>
								<p v-if="scope.row.fapzt == '4'" style="color:#FF8000">已开票</p>
								<p v-if="scope.row.fapzt == '5'" style="color:#FF8000">已作废</p>
								<p v-if="scope.row.fapzt == '6'" style="color:#FF8000">已红冲</p>
								<p v-if="scope.row.fapzt == '7'" style="color:#BEBEBE">开票失败</p>
								<p v-if="scope.row.fapzt == '8'" style="color:#00DC16">暂不开票</p>
								<p v-if="scope.row.fapzt == '9'" style="color:#00DC16">已退票</p>
								<p v-if="scope.row.fapzt == '10'" style="color:#00DC16">已合并</p>
								<p v-if="scope.row.fapzt == '21'" style="color:#00DC16">作废关闭中</p>
								<p v-if="scope.row.fapzt == '22'" style="color:#00DC16">作废重开中</p>
								<p v-if="scope.row.fapzt == '23'" style="color:#00DC16">作废锁定</p>
								<p v-if="scope.row.fapzt == '31'" style="color:#00DC16">未开发票冲销</p>
								<p v-if="scope.row.fapzt == '32'" style="color:#00DC16">已开发票冲销</p>
								<p v-if="scope.row.fapzt == '33'" style="color:#00DC16">作废冲销</p>
								<p v-if="scope.row.fapzt == '34'" style="color:#00DC16">无需开票</p>
								<p v-if="scope.row.fapzt == '35'" style="color:#00DC16">待作废</p>
							</template>
						</el-table-column>
						<el-table-column prop="fapzl" label="发票种类" min-width="100" align="center">
							<template slot-scope="scope">
								<p v-if="scope.row.fapzl == '1'">税控发票</p>
								<p v-if="scope.row.fapzl == '2'">数电发票</p>
							</template>
						</el-table-column>
						<el-table-column prop="invoiceTypeNumber" sortable="custom" label="发票类型" align="center" min-width="100">
							<template slot-scope="scope">
								<p v-if="scope.row.invoiceTypeNumber == '026'">电子普票</p>
								<p v-if="scope.row.invoiceTypeNumber == '028'">电子专票</p>
								<p v-if="scope.row.invoiceTypeNumber == '007'">纸质普票</p>
								<p v-if="scope.row.invoiceTypeNumber == '004'">纸质专票</p>
							</template>
						</el-table-column>
						<el-table-column type="invoiceId" width="55" v-if="show"></el-table-column>
						<el-table-column prop="invoiceCode" sortable="custom" label="发票代码" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="invoiceNumber" sortable="custom" label="发票号码" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="hejje" sortable="custom" label="金额" align="right" min-width="80px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="hejse" sortable="custom" label="税额" align="right" min-width="80px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="tedywlx" label="特殊业务" min-width="100" align="center">
							<template slot-scope="scope">
								<p v-if="scope.row.tedywlx == '01'">成品油</p>
								<p v-if="scope.row.tedywlx == '02'">稀土</p>
								<p v-if="scope.row.tedywlx == '03'">建筑服务</p>
								<p v-if="scope.row.tedywlx == '04'">货物运输</p>
								<p v-if="scope.row.tedywlx == '05'">不动产销售</p>
								<p v-if="scope.row.tedywlx == '06'">不动产经营租赁</p>
								<p v-if="scope.row.tedywlx == '07'">代收车船使用税</p>
								<p v-if="scope.row.tedywlx == '08'">通行费</p>
								<p v-if="scope.row.tedywlx == '09'">旅客运输</p>
								<p v-if="scope.row.tedywlx == '10'">医疗服务</p>
								<p v-if="scope.row.tedywlx == '11'">农产品</p>
								<p v-if="scope.row.tedywlx == '12'">拖拉机和联合收割机</p>
								<p v-if="scope.row.tedywlx == '13'">机动车</p>
								<p v-if="scope.row.tedywlx == '14'">光伏收购</p>
								<p v-if="scope.row.tedywlx == '15'">卷烟</p>
							</template>
						</el-table-column>
						<el-table-column prop="buyerName" label="购方名称" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="invoiceDate" label="开票日期" align="left" show-overflow-tooltip min-width="160px">
							<template slot-scope="scope">
								<div class="Centerhorizontally">{{ stringtostmp(scope.row.invoiceDate) }}</div>
							</template>
						</el-table-column>
						<el-table-column prop="emailAddress" label="邮箱地址" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column label="OFD生成状态" min-width="120px" align="center">
							<template slot-scope="scope">
								<div class="Centerhorizontally">
									<img src="../../../assets/img/ysc.png" width="31px" height="32px" v-if="scope.row.ofdGenerationState === '1'" />
									<span v-if="scope.row.ofdGenerationState === '00'">未生成</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="PDF生成状态" min-width="120px" align="center">
							<template slot-scope="scope">
								<div class="Centerhorizontally">
									<img src="../../../assets/img/ysc.png" width="31px" height="32px" v-if="scope.row.pdfGenerationState === '1'" />
									<span v-if="scope.row.pdfGenerationState === '00'">未生成</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="XML生成状态" min-width="120px" align="center">
							<template slot-scope="scope">
								<div class="Centerhorizontally">
									<img src="../../../assets/img/ysc.png" width="31px" height="32px" v-if="scope.row.xmlGenerationState === '1'" />
									<span v-if="scope.row.xmlGenerationState === '00'">未生成</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="邮件发送状态" min-width="120px" align="center">
							<template slot-scope="scope">
								<div class="Centerhorizontally">
									<img src="../../../assets/img/yfs.png" width="31px" height="32px" v-if="scope.row.emailSendState === '1'" />
									<span v-if="scope.row.emailSendState === '00'">未发送</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="卡包推送状态" min-width="120px" align="center">
							<template slot-scope="scope">
								<div class="Centerhorizontally">
									<img src="../../../assets/img/yts.png" width="31px" height="32px" v-if="scope.row.cardPushStaus === '1'" />
									<span v-if="scope.row.cardPushStaus === '00'">未推送</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="邮寄集成管理推送状态" min-width="160px" align="center">
							<template slot-scope="scope">
								<div class="Centerhorizontally">
									<img src="../../../assets/img/yts.png" width="31px" height="32px" v-if="scope.row.invoiceSendState === '1'" />
									<span v-if="scope.row.invoiceSendState === '00'">未推送</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" min-width="230" align="center">
							<template slot-scope="scope">
								<!-- 绑定时候渲染 -->
								<div class="distribution-line caozuo">
									<img src="../../../assets/img/ofdyl.png" width="37px" height="35px" v-permission="dpds_ofdyl" v-if="permissionButton('dpds_ofdyl','Telegraphicdelivery_FullyElectronic_ofd_preview')" @click="docPreviewRow(scope.row)" />
									<img src="../../../assets/img/yjfs.png" width="36px" height="33px" v-permission="dpds_yjfs" v-if="permissionButton('dpds_yjfs','Telegraphicdelivery_FullyElectronic_email_sending')" @click="sendEmailRow(scope.row)" />
									<!-- <img src="../../../assets/img/kbts.png" width="36px" height="33px" @click="sendCar([scope.row])" /> -->
									<img src="../../../assets/img/tsjl.png" width="36px" height="36px" v-permission="dpds_tsjl" v-if="permissionButton('dpds_tsjl','Telegraphicdelivery_FullyElectronic_push_record')" @click="showDetail(scope.row.invoiceId)" />
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!-- <div class="lastend">
                    <div>当前已勾选<span>{{selectionCount}}</span>条</div>
                </div> -->
				<div class="buttompage">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[10, 20, 100, 500]"
						:page-size="pagenum"
						:key="elementui_page_component_key"
						:current-page="currentpage"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalcount"
					></el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="showPDF" width="1000px" :close-on-click-modal="false" v-dialogDrag title="发票预览">
			<pdf ref="pdf" :src="pdfUrl"></pdf>

			<div style="margin-top: 31px;padding-bottom: 21px;" class="between-line">
				<div></div>
				<div style="justify-content: right; display: flex;margin-top: 10px"><div class="backstyle" style="width:60px" @click="showPDF = false">关闭</div></div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import configHttp from '../../../../configHttp';
import pdf from 'vue-pdf';
import axios from 'axios';

export default {
	components: {
		pdf
	},
	data() {
		return {
			projectName: '',
			searchlist: [
				{
					prop: 'faplxdm',
					label: '单据类型',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '纸质普票',
							value: '007'
						},
						{
							label: '纸质专票',
							value: '004'
						},
						{
							label: '电子普票',
							value: '026'
						},
						{
							label: '电子专票',
							value: '028'
						}
					]
				},
				{ prop: 'invoiceNumber', label: '发票号码', type: 'input' },
				{ prop: 'invoiceCode', label: '发票代码', type: 'input' },
				{ prop: 'invoiceDate', label: '开票日期', type: 'date', valueformat: 'yyyyMMddHHmmss' },
				{ prop: 'buyerName', label: '购方名称', type: 'input' },
				{ prop: 'danjh', label: '单据号', type: 'input' },
				{
					prop: 'kaiplx',
					label: '负数发票',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '正数',
							value: '0'
						},
						{
							label: '负数',
							value: '1'
						}
					]
				},
				{
					prop: 'pdfGenerationState',
					label: 'PDF生成状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '未生成',
							value: '00'
						},
						{
							label: '已生成',
							value: '1'
						}
					]
				},
				{
					prop: 'ofdGenerationState',
					label: 'OFD生成状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '未生成',
							value: '00'
						},
						{
							label: '已生成',
							value: '1'
						}
					]
				},
				{
					prop: 'emailSendState',
					label: '邮件发送状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '未发送',
							value: '00'
						},
						{
							label: '已发送',
							value: '1'
						}
					]
				},
				{
					prop: 'cardSendState',
					label: '卡包推送状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '未推送',
							value: '00'
						},
						{
							label: '已推送',
							value: '1'
						}
					]
				},
				{
					prop: 'invoiceSendState',
					label: '邮寄集成推送状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '未推送',
							value: '00'
						},
						{
							label: '已推送',
							value: '1'
						}
					]
				},
				{
					prop: 'danjzt',
					label: '单据状态',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '已开票',
							value: '4'
						},
						{
							label: '已红冲',
							value: '6'
						},
						{
							label: '已作废',
							value: '5'
						}
					]
				},
				{
					prop: 'fapzl',
					label: '发票种类',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '税控发票',
							value: '1'
						},
						{
							label: '数电发票',
							value: '2'
						}
					]
				},
				{
					prop: 'tedywlx',
					label: '特殊业务',
					type: 'select',
					selectval: [
						{
							label: '全部',
							value: ''
						},
						{
							label: '成品油',
							value: '01'
						},
						{
							label: '稀土',
							value: '02'
						},
						{
							label: '建筑服务',
							value: '03'
						},
						{
							label: '不动产经营租赁',
							value: '06'
						},
						{
							label: '机动车',
							value: '13'
						}
					]
				}
			],
			pdfUrl: '',

			formLabelWidth: '150px',
			cxdialog: false,
			changedialog: false,
			docPreviewDialog: false,
			pdfPreviewUrl: '',
			page: 1,
			pagenum: 10,
			totalcount: 10,
			advancedQueryForm: {},
			editEmailForm: {
				emailAddress: ''
			},
			dateall: '',
			headtitle: ['发票管理', '电票递送'],
			likeQueryModel: '',
			cxtitle: ['高级查询'],
			changetitle: ['修改邮箱'],
			docPreview: ['发票预览'],
			writeval: '',
			show: false,
			tableData: '',
			selectionChange: [],
			sendType: '',
			selectionCount: -1,
			detailTableData: [{}, {}, {}, {}],
			showDocPushHistory: false,
			showPDF: false,
			tableHeight: '',
			currentpage: 1,
			elementui_page_component_key: '',
			selectRows: [],
			ifsrc: '',
			pdftype: '',
			/* 高级查询搜索条件 */
			searchalllist: {
				faplxdm: '',
				invoiceCode: '',
				invoiceNumber: '',
				invoiceStartdate: '',
				invoiceEnddate: '',
				buyerName: '',
				danjh: '',
				danjzt: '',
				kaiplx: '',
				pdfGenerationState: '',
				ofdGenerationState: '',
				emailSendState: '',
				cardSendState: '',
				invoiceDate: '',
				invoiceSendState: ''
			},
			isshou: true,
			fpxlxoptions: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '纸质普票',
					value: '007'
				},
				{
					label: '纸质专票',
					value: '004'
				},
				{
					label: '电子普票',
					value: '026'
				},
				{
					label: '电子专票',
					value: '028'
				}
			],
			sort: 'desc',
			order: 'id',
			pageRoles:"",
			pageRolesButtons:{},
			
		};
	},
	activated(){
		console.log("activated")
	},
	watch: {
	  '$route': 'refreshData'
	},
	created() {
		
		this.projectName = configHttp.projectName;
		
		this.commonQuery();
		this.loadPermissionButton();
	},
	mounted() {
		this.repairtable();
	},
	methods: {
		refreshData() {
		    // 刷新数据的代码
			console.log('refreshData');
			this.loadPermissionButton();
		},
		loadPermissionButton() {
		    this.pageRoles = this.$route.meta.roles[0]
			var userFunction = JSON.parse(localStorage.getItem('userFunction'));
			userFunction.forEach(item => {
				if (this.notemptyandnull(item.children)) {
					item.children.forEach(gtem => {
						if (gtem.index == this.pageRoles) {
							this.pageRolesButtons = JSON.parse(JSON.stringify(gtem.buttomroute));
							console.log(this.pageRolesButtons)
						}
					});
				}
			});
		},
		permissionButton(...ifRoles) {
			for (let i = 0; i < ifRoles.length; i++) {
				let str = ifRoles[i];
				let haveButton = this.pageRolesButtons[str];
				if (!!haveButton){
					console.log(' =>true');
					return true
				} 

			}
			return false;
		},
		repairtable() {
			this.$nextTick(() => {
				this.tableHeight = this.diagheightzhengshutiankai();
				setTimeout(() => {
					this.$refs.multipleTable.doLayout();
				}, 300);
				window.onresize = () => {
					this.tableHeight = this.diagheightzhengshutiankai();
					setTimeout(() => {
						this.$refs.multipleTable.doLayout();
					}, 300);
				};
			});
		},
		tableRowClassName({ row, rowIndex }) {
			//把每一行的索引放进row
			row.index = rowIndex;
		},
		forserchinput() {
			this.currentpage = 1;
			this.elementui_page_component_key++;
			this.page = 1;
			Object.keys(this.advancedQueryForm).map(key => (this.advancedQueryForm[key] = ''));
			this.commonQuery();
		},
		close() {
			this.cxdialog = false;
		},
		reset() {
			Object.keys(this.advancedQueryForm).map(key => (this.advancedQueryForm[key] = ''));
		},
		handleSizeChange(val) {
			this.pagenum = val;
			this.commonQuery();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.commonQuery();
		},
		handleSelectionChange(e) {
			this.selectRows = [];
			e.forEach((item, index) => {
				this.selectRows.push(item);
			});
		},
		selectClick(row, column, event) {
			this.$refs.multipleTable.toggleRowSelection(row);
		},
		tableSortChange(column, prop, order) {
			this.order = column.prop;
			if (column.order) {
				this.sort = column.order.replace('ending', '');
			} else {
				this.sort = '';
				this.order = '';
			}
			this.commonQuery();
		},
		/* 高级查询弹框 */
		advancedQueryPopUp() {
			this.cxdialog = true;
		},
		/* 高级查询 */
		advancedQuery() {
			this.likeQueryModel = '';
			this.cxdialog = false;
			this.commonQuery();
		},
		/* 共用查询方法 */
		commonQuery() {
			var newForm = JSON.parse(JSON.stringify(this.searchalllist));
			if (newForm.invoiceDate) {
				newForm.invoiceDate = newForm.invoiceDate.join(',');
			}
			let params = {
				likeSearch: JSON.parse(JSON.stringify(this.likeQueryModel)),
				page: this.page,
				limit: this.pagenum,
				search: newForm,
				sort: this.sort,
				order: this.order
				//search: this.processDate(JSON.parse(JSON.stringify(this.advancedQueryForm)))
			};

			// if(configHttp.shuangRiTaxNumber){
			//   let shuangRiTaxNumber = configHttp.shuangRiTaxNumber;
			//   console.log(shuangRiTaxNumber);
			//   let userobj=JSON.parse(localStorage.getItem("useropj"));
			//   let qiybh=userobj.currCompany.code;
			//   if(shuangRiTaxNumber.includes(qiybh)){
			//     params.search.cank4='3';
			//   }
			// }
			this.$https.fetchPost('electronic/invoice/search', params).then(res => {
				this.totalcount = res.data.count;
				this.tableData = res.data.data;
			});
		},
		/* 修改邮箱 */
		changeEmail() {
			if (!this.validateIsSelectData(this.selectRows)) return;
			this.editEmailForm.emailAddress = this.selectionChange.emailAddress;
			this.changedialog = true;
		},
		/* 保存邮箱变更 */
		saveEmailChange() {
			if (!this.validateEmailAddress(this.editEmailForm.emailAddress)) return;
			var ids = [];
			this.selectRows.forEach((item, index) => {
				ids.push(item.invoiceId);
			});
			this.$https
				.fetchPost('electronic/invoice/edit/email', {
					ids: ids,
					emailAddress: this.editEmailForm.emailAddress
				})
				.then(res => {
					if (res.data.success) {
						this.commonQuery();
						this.changedialog = false;
					}
				});
		},
		/* 发送邮箱 行内方式 */
		sendEmailRow(e) {
			let reg = /^([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})$/;
			if (this.validateIsEmpty(e.emailAddress)) {
				if (this.isyxk) {
					this.$message({
						type: 'warning',
						message: '推送失败，邮箱地址未维护'
					});
				} else {
					this.$message({
						type: 'warning',
						message: '邮箱地址不能为空'
					});
				}
				return false;
			}
			var emailLen = e.emailAddress.split(';');
			for (var email in emailLen) {
				if (emailLen[email].length > 100 || !reg.test(emailLen[email])) {
					this.$message({
						type: 'warning',
						message: '请输入有效的邮箱地址'
					});
					return false;
				}
			}
			this.sendEmail([e]);
		},
		/* 发送邮箱 按钮 */
		sendEmailButton() {
			this.sendEmail(this.selectRows);
		},
		/* 推送票必答 行内方式 */
		sendInvoiceRow(e) {
			this.sendInvoice(e);
		},
		/* 推送票必答 按钮 */
		sendInvoiceButton() {
			this.sendInvoice(this.selectRows);
		},
		/* OFD预览 行内方式 */
		docPreviewRow(e) {
			this.ifsrc = '';
			if (e.fapzl == '2') {
				// this.$message("数电发票暂时不支持ofd预览");
				let requestUrl = this.$https.baseURL + 'felec/manual/viewFelec'; //请求下载文件的地址
				let param = {
					danjh: e.danjh
				};
				// axios.post(requestUrl,param,{responseType:"blob"}).then(res => {
				// })
				this.$https.fetchdowload(requestUrl, param).then(res => {
					let url = null;
					this.showPDF = true;
					const content = res.data;
					let file = new Blob([content], { type: 'application/pdf;chartset=utf-8' });
					if (window.createObjectURL != undefined) {
						// 通用
						url = window.createObjectURL(file);
					} else if (window.webkitURL != undefined) {
						// 兼容谷歌
						try {
							url = window.webkitURL.createObjectURL(file);
						} catch (error) {
							console.log(error);
						}
					} else if (window.URL != undefined) {
						// 兼容其他
						try {
							url = window.URL.createObjectURL(file);
						} catch (error) {
							console.log(error);
						}
					}
					// 将转化后url赋值
					this.pdfUrl = url;
					console.log(this.pdfUrl);
				});

				return false;
			}
			if (e.previewUrl != undefined && e.previewUrl != '') {
				this.ifsrc = e.previewUrl;
				this.docPreviewDialog = true;
				this.pdftype = '';
			} else {
				if (e.ofdGenerationState === '00') {
					this.$message({
						type: 'error',
						message: '预览失败：发票号码[' + e.invoiceNumber + ']OFD文件未生成'
					});
					return false;
				}
				let pdfUrl = 'http://' + window.location.host + '/pdf/' + e.invoiceCode + e.invoiceNumber + '.pdf';
				this.ifsrc = pdfUrl;
				this.docPreviewDialog = true;
				this.pdftype = 'application/x-google-chrome-pdf';
			}
		},
		/* 生成OFD */
		createOfd() {
			if (!this.validateIsSelectData(this.selectRows)) return;
			this.$confirm('生成OFD操作会自动忽略纸质发票，确定要生成吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				if (this.isyxk) {
					var exist = false;
					var ids = [];
					this.selectRows.forEach((item, index) => {
						if (item.invoiceTypeNumber === '026' || item.invoiceTypeNumber === '028') {
							if (item.ofdGenerationState === '1') {
								exist = true;
							}
							ids.push(item.invoiceId);
						}
					});
					if (exist) {
						this.$confirm('所选数据OFD已存在，确定要重新生成吗？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.fetchPostCreateOfd(ids);
						});
					} else {
						this.fetchPostCreateOfd(ids);
					}
				} else {
					var ids = [];
					this.selectRows.forEach((item, index) => {
						if (item.invoiceTypeNumber === '026' || item.invoiceTypeNumber === '028') {
							ids.push(item.invoiceId);
						}
					});
					this.fetchPostCreateOfd(ids);
				}
			});
		},
		/* 生成PDF */
		createPdf() {
			if (!this.validateIsSelectData(this.selectRows)) return;
			var ids = [];
			this.selectRows.forEach((item, index) => {
				ids.push(item.invoiceId);
			});
			this.fetchPostCreatePdf(ids);
		},
		/* 邮件发送 */
		sendEmail(val) {
			if (!this.validateIsSelectData(val)) return;
			this.fetchPostSendEmail(val);
		},
		/* 推送卡包 */
		sendCar(val) {
			var ids = [];
			val.forEach((item, index) => {
				ids.push(item.invoiceId);
			});
			this.$https.fetchPost('/electronic/invoice/pushCar', ids).then(res => {
				if (res.data.success) {
					this.commonQuery();
				}
			});
		},
		/* 推送票必答 */
		sendInvoice(val) {
			if (!this.validateIsSelectData(val)) return;
			this.fetchPostSendInvoice(val);
		},
		/* OFD预览 */
		ofdPreview(val) {
			//if (!this.validateOfdIsCreate(val)) return;
			//this.fetchPostOfdPreview(val);
			window.open(val.previewUrl);
		},
		fetchPostOfdPreview(val) {
			this.$https.fetchPost('/electronic/invoice/getPfdPreviewUrl/' + val['invoiceId']).then(res => {
				window.open(res.data);
			});
		},
		fetchPostCreateOfd(ids) {
			this.$https.fetchPost('/electronic/invoice/create/ofd', ids).then(res => {
				if (res.data.success) {
					setTimeout(() => {
						this.commonQuery();
					}, 1000);
				}
			});
		},
		fetchPostCreatePdf(ids) {
			this.$https.fetchPost('/electronic/invoice/create/pdf', ids).then(res => {
				if (res.data.success) {
					setTimeout(() => {
						this.commonQuery();
					}, 1000);
				}
			});
		},
		fetchPostSendEmail(val) {
			console.log(val);
			let checkSuccess = false;
			this.selectRows.forEach((item, index) => {
				if (this.validateIsEmpty(item.emailAddress)) {
					if (this.isyxk) {
						this.$message({
							type: 'warning',
							message: '推送失败，邮箱地址未维护'
						});
					} else {
						this.$message({
							type: 'warning',
							message: '邮箱地址不能为空'
						});
					}
					checkSuccess = true;
				} else {
					let reg = /^([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})$/;
					var emailLen = item.emailAddress.split(';');
					for (var email in emailLen) {
						if (emailLen[email].length > 100 || !reg.test(emailLen[email])) {
							this.$message({
								type: 'warning',
								message: '请输入有效的邮箱地址'
							});
							checkSuccess = true;
							break;
						}
					}
				}
				// if (!this.validateEmailAddress(item.emailAddress)) checkSuccess=true;
			});
			if (!checkSuccess) {
				var ids = [];

				this.selectRows.forEach((item, index) => {
					ids.push(item.invoiceId);
				});
				if (!ids.length) {
					ids.push(val[0].invoiceId);
				}

				this.$https.fetchPost('/electronic/invoice/send/email', ids).then(res => {
					if (res.data.success) {
						setTimeout(() => {
							this.commonQuery();
						}, 1000);
					}
				});
			}
		},
		fetchPostSendInvoice(val) {
			var ids = [];
			this.selectRows.forEach((item, index) => {
				ids.push(item.invoiceId);
			});
			this.$https.fetchPost('/electronic/invoice/delivery/invoice', ids).then(res => {
				if (res.data.success) {
					this.commonQuery();
				}
			});
		},
		validateEmailAddress(val) {
			if (this.validateIsEmpty(val)) {
				this.$message({
					type: 'warning',
					message: '邮箱地址不能为空'
				});
				return false;
			}
			let reg = /^([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})$/;
			var emailLen = val.split(';');
			for (var email in emailLen) {
				if (emailLen[email].length > 100 || !reg.test(emailLen[email])) {
					this.$message({
						type: 'warning',
						message: '请输入有效的邮箱地址'
					});
					return false;
				}
			}
			return true;
			// if (val.length > 100 || !reg.test(val)) {
			//     this.$message({type: 'warning', message: '请输入有效的邮箱地址'});
			//     return false;
			// }
			// return true;
		},
		validateIsSelectData(val) {
			if (this.validateIsEmpty(val) || val.length < 1) {
				this.$message({
					type: 'warning',
					message: '请选择要操作的数据'
				});
				return false;
			}
			return true;
		},

		validateOfdIsCreate(val) {
			if (val['ofdGenerationState'] === '00') {
				this.$message({
					type: 'error',
					message: '预览失败：发票号码[' + val['invoiceNumber'] + ']OFD文件未生成'
				});
				return false;
			}
			return true;
		},
		validateIsEmpty(val) {
			return val === undefined || val === null || val === '' || val.length < 1;
		},
		processDate(val) {
			if (!this.validateIsEmpty(val['invoiceDate'])) {
				val['invoiceDate'] = JSON.stringify(val['invoiceDate']);
			}
			return val;
		},
		sendCarBatch() {
			if (!this.validateIsSelectData(this.selectRows)) return;
			this.sendCar(this.selectRows);
		},
		showDetail(id) {
			this.$https.fetchPost('/electronic/invoice/getDocPushHistoryList', id).then(res => {
				this.detailTableData = res.data.obj;
				this.showDocPushHistory = true;
			});
		},
		formatDateTime(inputTime) {
			var date = new Date(inputTime); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			m = m < 10 ? '0' + m : m;
			var d = date.getDate();
			d = d < 10 ? '0' + d : d;
			var h = date.getHours();
			h = h < 10 ? '0' + h : h;
			var minute = date.getMinutes();
			var second = date.getSeconds();
			minute = minute < 10 ? '0' + minute : minute;
			second = second < 10 ? '0' + second : second;
			return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
		},
		changeshou() {
			this.isshou = !this.isshou;
		},
		//重置
		resetForm(formName) {
			Object.keys(this.searchalllist).map(key => (this.searchalllist[key] = ''));
		},
		forshuai() {
			this.elementui_page_component_key++;
			this.currentpage = 1;
			this.page = 1;
			if (this.searchalllist.invoiceDate) {
				this.searchalllist.invoiceStartdate = this.searchalllist.invoiceDate[0];
				this.searchalllist.invoiceEnddate = this.searchalllist.invoiceDate[1];
			}
			delete this.searchalllist['alldate'];
			delete this.searchalllist['fpalldate'];
			this.commonQuery();
		},
		downloadDoc(fileType) {
			let dianzOrZhizFpFlag;
			// 下载板式文件 TODO 支持纸票pdf
			if (this.selectRows.length == 0) {
				this.$message.error('请选择需要下载的发票');
				return;
			}
			if (this.selectRows.every(row => row.faplxdm === '026' || row.faplxdm === '028')) {
				// this.$message.error("当前仅支持电子发票下载")
				// return;
				dianzOrZhizFpFlag = true;
			} else {
				dianzOrZhizFpFlag = false;
			}
			if (!dianzOrZhizFpFlag) {
				if (fileType == 2) {
					this.$message.error('纸质普通发票仅支持PDF版式文件下载');
					return;
				}
			}
			var ids = [];
			this.selectRows.forEach((item, index) => {
				ids.push(item.invoiceId);
			});
			let row = this.selectRows[0];
			let params = {
				ids: ids,
				business: 'doc',
				fileType: fileType
			};
			this.$https.fetchdowload('real/downloadDoc', params).then(res => {
				if (res.data.size === 0) {
					this.$message.info('下载文件失败。');
					return;
				}
				const content = res.data;
				const blob = new Blob([content]);
				var date = new Date().getFullYear() + '' + (new Date().getMonth() + 1) + '' + new Date().getDate();
				var fileName;
				fileName = res.headers['content-disposition'].split(';')[1].split('=')[1];
				if ('download' in document.createElement('a')) {
					// 非IE下载
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				} else {
					// IE10+下载
					navigator.msSaveBlob(blob, fileName);
				}
			});
		}
	}
};
</script>

<style scoped="scoped" lang="less">
/deep/ .el-radio__label {
	display: none;
}

.caozuo > img {
	cursor: pointer;
}

.bt1 {
	width: 56px;
	height: 30px;
	border: 1px solid #e5e5e5;
	border-radius: 3px;
	font-size: 14px;
	font-weight: 500;
	color: #2f66fc;
}

.bt2 {
	width: 93px;
	height: 32px;
	background: #2f66fc;
	border-radius: 2px;
	font-size: 15px;
	font-weight: 400;
	cursor: pointer;
	color: #ffffff;
}

.bt3 {
	width: 93px;
	height: 32px;
	background: #e2e2e2;
	border-radius: 2px;
	font-size: 15px;
	font-weight: 400;
	cursor: pointer;
	margin-left: 53px;
	color: #ffffff;
}

// /deep/ .el-dialog__body {
// 	padding: 0;
// }

/deep/ .el-table--small td {
	padding: 4px 0;
}

/deep/ .el-table__body-wrapper {
	min-height: 160px;
}

.areatable {
	margin-top: 16px;
}

.aftericon:extend(.Centerhorizontally) {
	width: 36px;
	height: 33px;
	background: #ffffff;
	box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.09);
	opacity: 1;
	border-radius: 3px;
	margin-left: 20px;
}

.aftericon > img {
	width: 16px;
	height: 16px;
}

.areacontent {
	margin-left: 21px;
}

/deep/ .el-input--suffix .el-input__inner {
	padding-right: 15px;
}

.minheight {
	height: 40px;
	overflow: hidden;
	transition: all 0.3s ease;
}

.maxheight {
	height: 260px;
	transition: all 0.3s ease;
}

.shousuo:extend(.Verticalcenter) {
	height: 20px;
	margin-bottom: 10px;
	background-color: #f8f8f8;
}

.shousuo:hover {
	background: #f8f8f8;
}

.alltopform > div {
	margin-left: 60px;
}
</style>
